<template>
<div>
  <div class="case-tabs">
    <div
      :class="['case-tab', current_tab == 'Sifarnik' ? 'active' : '',]"
      @click="changeView('sifarnik')"
    >
      Šifarnici
    </div>
    <!-- <div
      :class="[
        'case-tab',
        current_tab == 'Tarife' ? 'active' : '',
      ]"
      @click="changeView('tarife')"
    >
      Tarifa
    </div> -->
    <!-- <div
      :class="['case-tab', current_tab == 'Fakture' ? 'active' : '',]"
      @click="changeView('fakture')"
    >
      Fakture
    </div> -->
  </div>
</div>

</template>

<script>

export default {
    props:['current_tab'],
  methods: {

    changeView(nastavak) {
        this.$router.push("/"+nastavak);

    }
  },
  mounted() {
  },
  destroyed(){
  }
};
</script>